import styled from 'styled-components';
import { InfoWrapperSC } from './../../../auth.styled';

export const StepLandingSC = styled(InfoWrapperSC)`
  h1 {
    text-align: left;
  }

  @media screen and (max-width: 500px) {
    grid-template-columns: 0.1fr 4fr;
  }
`;
